<template>
  <div class="cabinet-header">
    <QrAppDialog v-model="qrDialog" />
    <div class="navigation" style="overflow: auto">
      <router-link
        v-for="(navigationItem, navigationIndex) in navigationItems"
        :class="{ 'inner-link': navigationItem.hasInnerRoutes }"
        class="navigation-item"
        :to="navigationItem.to"
        :key="navigationIndex"
      >
        {{ $t(navigationItem.text) }}
        <span
          style="color: var(--v-anchor-base)"
          class="ml-1"
          v-if="navigationItem.text === 'Сообщения'"
          >{{ mailCount }}</span
        >
      </router-link>
      <div class="float-right d-flex align-center" style="height: 60px">
        <Profile />
      </div>
      <div v-if="freeUser" class="app-container float-right d-flex">
        <v-col class="px-2">
          <v-btn color="primary" icon @click="appStoreDialog"
            ><v-icon>{{ mdiQrcodeScan }}</v-icon></v-btn
          >
        </v-col>
      </div>
    </div>
    <v-divider />
  </div>
</template>

<script lang="ts">
export default {
  name: "CabinetHeader",
};
</script>

<script lang="ts" setup>
import Profile from "@/components/profile/Profile.vue";
import mailModule from "@/store/mail.module";
import authModule from "@/store/auth.module";
import { computed, onMounted, ref } from "vue";
import QrAppDialog from "@/components/ui/QrAppDialog.vue";
import { mdiQrcodeScan } from "@mdi/js";
import { ROLE_STORONA_IP } from "@/config/const";

const qrDialog = ref(false);

const navigationItems = computed(() => {
  return [
    ...(authModule.isEmployer
      ? [
          {
            text: "Поступившие запросы",
            to: "/requests",
            hasInnerRoutes: true,
          },
          {
            text: "Сотрудники с постановлением о взыскании с З/П",
            to: "/employees-with-penalty",
          },
          {
            text: "Список постановлений о взыскании с З/П",
            to: { name: "WageOrders" },
            hasInnerRoutes: true,
          },
        ]
      : []),
    ...(authModule.isClaimant
      ? [
          { text: "Аналитика", to: "/claimant-analytics" },
          {
            text: "Исполнительные производства",
            to: "/claimant-productions",
          },
          {
            text: "Меры",
            to: "/claimant-arrests",
          },
          {
            text: "Мониторинг статуса ИП и принудительных мер",
            to: "/claimant-monitoring",
          },
        ]
      : []),
    ...(!authModule.isEmployer
      ? [
          {
            text: "notifications",
            to: "/notifications",
            hasInnerRoutes: true,
          },
          {
            text: "Исполнительные производства",
            to: "/exec-productions",
          },
          // {
          //   text: "Подача заявления ЧСИ",
          //   to: "/statements",
          //   hasInnerRoutes: true,
          // },
        ]
      : []),
    ...(authModule.onlyStoronaIp || authModule.storonaIpLeader
      ? [
          {
            text: "Повторное предъявление",
            to: "/resubmissions",
            hasInnerRoutes: true,
          },
        ]
      : []),
    ...(authModule.onlyStoronaIp || authModule.storonaIpLeader
      ? [
          {
            text: "Банковские реквизиты",
            to: "/bank-details",
            hasInnerRoutes: true,
          },
          {
            text: "Обращения",
            to: "/citizen-applications",
            hasInnerRoutes: true,
          },
        ]
      : []),
  ];
});

const mailCount = computed(() => {
  return mailModule.notificationsCount.unreadNotifications || "";
});

const appStoreDialog = async () => {
  qrDialog.value = true;
};

const freeUser = computed(() => {
  return authModule.roles.includes(ROLE_STORONA_IP);
});

onMounted(() => {
  if (freeUser.value) appStoreDialog();
});
</script>
<style lang="scss">
@import "~vuetify/src/styles/styles.sass";

.cabinet-header {
  .navigation {
    margin: 0px 70px;
    .navigation-item {
      color: var(--v-primary-base) !important;
      @include fontSize(14, 16);
      text-transform: uppercase;
    }

    .navigation-item.router-link-exact-active::after,
    .navigation-item.inner-link.router-link-active::after,
    .navigation-item:hover::after {
      background: var(--v-primary-base) !important;
    }
  }
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    .navigation {
      margin: 0px 14px;
    }
  }
}

.app-container {
  // border: 1px outset #09405a;
  border-radius: 10px;
  display: flex;
  align-items: center;
  height: 45px;
  // width: 105px;
  margin: 7px 10px 0 0;
}
</style>
